import React, {memo} from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';

class Button extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        children: '',
        disabled: false,
        type: 'default',
        size: 'default'
    };

    static propTypes = {
        children: PropTypes.string, // 按钮文案
        disabled: PropTypes.bool, // 按钮是否禁用
        type: PropTypes.string, // 按钮类型 default primary warn
        size: PropTypes.string, // 按钮尺寸  default-32px large-40px small-24px
    };

    componentDidMount() {
    }


    render() {
        const {
            children,
            type,
            size,
            disabled,
            ...rest
        } = this.props;

        return (
            <button
                className={`common-button type-${type} size-${size} ${disabled ? 'disabled' : ''}`}
                {...rest}
            >{children || ''}</button>
        )
    }
}
export default Button;